import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const AGENT_COLOR = "#2196F3";
const LIVE_COLOR = "#FF9800";

const DispositionByAgentChart = ({ dispositionByAgentType }) => {
  if (!dispositionByAgentType || dispositionByAgentType.length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Disposition by Call Type</h4>
        <div className="no-data-message">No disposition comparison data available</div>
      </div>
    );
  }

  const data = dispositionByAgentType.map(item => ({
    disposition: item.disposition,
    Agent: item.aiCount,
    Live: item.liveCount
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Disposition by Call Type</h4>
      <ResponsiveContainer height={250}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 20, right: 30, left: 100, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="disposition" type="category" width={90} />
          <Tooltip />
          <Legend />
          <Bar dataKey="Agent" fill={AGENT_COLOR} />
          <Bar dataKey="Live" fill={LIVE_COLOR} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

DispositionByAgentChart.propTypes = {
  dispositionByAgentType: PropTypes.arrayOf(
    PropTypes.shape({
      disposition: PropTypes.string,
      aiCount: PropTypes.number,
      liveCount: PropTypes.number
    })
  )
};

export default DispositionByAgentChart;
